import {SubAPI} from "./SubAPI";
import {Paginated} from "./Users";
import {DateString} from "./Projects";

export class Tasks2 extends SubAPI {
    listTags(input: {
        search?: string;
        offset?: number;
    }) {
        return this.fetcher.get<Paginated<Tag>>("/api/task2/tags", input)
    }

    updateTag(input: Tag) {
        return this.fetcher.post("/api/task2/tag", input)
    }

    get(input: {id: number}) {
        return this.fetcher.get<Task2>("/api/task2", input)
    }

    update(input: Task2) {
        return this.fetcher.post<Task2>("/api/task2", input)
    }

    handleSearch(input: {
        search: string;
        biasProject?: number;
    }) {
        return this.fetcher.get<HandleResult[]>("/api/task2/handle-search", input)
    }

    updateComment(input: TaskComment) {
        return this.fetcher.post("/api/task2/comment", input)
    }

    listWatchers(input: {
        task2: number;
    }) {
        return this.fetcher.get<Watcher[]>("/api/task2/watchers", input)
    }

    updateWatchers(input: Watcher[]) {
        return this.fetcher.post<Watcher[]>("/api/task2/watchers", input)
    }

    listAssignments(input: {
        task2: number;
    }) {
        return this.fetcher.get<Assignment[]>("/api/task2/assigned", input)
    }

    updateAssignments(input: Assignment[]) {
        return this.fetcher.post<Assignment[]>("/api/task2/assigned", input)
    }

    myAssigned(input: {}) {
        return this.fetcher.get<TaskSimple[]>("/api/task2/my-assigned", input)
    }

    getBoard(input: {
        id?: number;
        key?: string;
        project?: number;
        user?: number;
    }) {
        return this.fetcher.get<TaskBoard>("/api/task2/board", input)
    }

    upsertBoard(input: TaskBoard) {
        return this.fetcher.post("/api/task2/board", input)
    }

    getBoardColumnContent(input: {
        column: number;
    }) {
        return this.fetcher.get<TaskBoardCard[]>("/api/task2/board/column-content", input)
    }

    updateBoardColumn(input: TaskBoardColumn) {
        return this.fetcher.post("/api/task2/board/column", input)
    }

    updateCardPosition(input: {
        id: number;
        column: number;
        index: number;
    }) {
        return this.fetcher.post("/api/task2/board/card-position", input)
    }

    updateBoardWatchers(input: BoardWatcher[]) {
        return this.fetcher.post<BoardWatcher[]>("/api/task2/board/watchers", input)
    }

    getBoardWatchers(input: {
        board: number;
    }) {
        return this.fetcher.get<BoardWatcher[]>("/api/task2/board/watchers", input)
    }

    newCardOnBoard(input: {
        title: string;
        column: number;
    }) {
        return this.fetcher.post("/api/task2/board/new-card", input)
    }

    updateCard(input: TaskBoardCard) {
        return this.fetcher.post("/api/task2/board/card", input)
    }
}

export type HandleResult = {
    id: number;
    display: string;
    type: string;
}

export type TaskBoard = {
    id: number;
    title: string;
    key: string;
    project?: number;
    usr?: number;
    archived: boolean;

    columns?: TaskBoardColumn[]
}

export type TaskBoardColumn = {
    id: number;
    board: number;
    boardTitle: string;
    title: string;
    archived: boolean;
    sortOrder: number;
    autoAddRule: {} | any;
    completedColumn: boolean;

    cards?: TaskBoardCard[];
}

export type TaskBoardCard = {
    id: number;
    board: number;
    bardColumn: number;
    task2: number;
    task2Obj: TaskSimple;
    sortOrder: number;
    archived: boolean;
    isComplete: boolean;
}

export type TaskSimple = {
    id: number;
    title: string;
    description: string;
    kind: TaskKind
    meta: any;
    archived: boolean;
    dueDate: string | null;

    boardTitle: string;
    boardUrl: string;

    tags?: TaskTagSimple[];
}

type TaskTagSimple = {
    id: number;
    name: string;
    color: string;
}

export type Task2 = {
    id: number;
    title: string;
    description: string;
    kind: TaskKind
    meta: any;
    archived: boolean;
    dueDate: DateString | null;

    assignment?: Assignment[]
    watchers?: Watcher[];
    tags?: TaskTag[];
    events?: TaskEvent[];
    boardLinks?: BoardCardSimple[];
}

export type BoardCardSimple = {
    board: number;
    boardName: string;
    boardUrl: string;
    card: number;
    columnName: string;
}

export type TaskKind = "";
export type Assignment = {
    id: number;
    task2: number;
    usr: number;
    usrName: string;
    archived: boolean;
}

export type Watcher = {
    id: number;
    task2: number;
    usr: number;
    usrName: string;
    archived: boolean;
}

export type BoardWatcher = {
    id: number;
    board: number;
    usr: number;
    usrName: string;
    archived: boolean;
}

export type TaskTag = {
    id: number;
    tag: number;
    tagName: string;
    tagColor: string;
    archived: boolean;
}

export type TaskEvent = {
    id: number;
    task2: number;
    createdAt: DateString;
    comment: number;
    commentObj: TaskComment;
    description: string;
    meta: EventMeta;
}

export type EventMeta = {
    tag: number;
    tagName: string;
    tagColor: string;

    usr: number;
    usrName: string;

    targetUsr: number;
    targetUsrName: string;

    oldTitle: string;
    newTitle: string;

    oldColumn: string;
    newColumn: string;
}

export type TaskComment = {
    id: number;
    task2: number;

    body: string;

    createdAt: DateString;
    updateAt: DateString;
    createdByName: string;
    createdBy: number;
    archived: boolean;
}

export type Tag = {
    id: number;
    name: string;
    color: string;
    archived: boolean;
}